import { AxiosInstance } from "axios";
import { Result } from "services/Result";
import { IStatusDataResponse } from "../../pages/StatusTable/interfaces/IStatusData";
import { ISystemProvider } from "interfaces/providers/ISystemProvider";
import { ISystemData } from "pages/Map/components/interfaces";

export class WomApiService implements ISystemProvider {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getSystems = async () => {
    let response = await this.axiosInstance.get<Result<ISystemData[]>>(
      "api/system"
    );
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error("Failed to fetch systems: " + response.status);
  };

  getStatus = async (params: string | undefined, skip, take) => {
    let response = await this.axiosInstance.get<Result<IStatusDataResponse>>(
      // "status" + params
      `status?skip=${skip}&take=${take}${params ? `${params}` : ""}`
    );
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error("Failed to fetch statuses: " + response.status);
  };
}
